export const SHOW_LOADING = 'loading/SHOW_LOADING';
export const HIDE_LOADING = 'loading/HIDE_LOADING';

export type LoadingState = {
  open: boolean;
};
